//action types
export const MIGRATE_USER_LEGACY_SEND = 'MIGRATE_USER_LEGACY_SEND';
export const MIGRATE_USER_LEGACY_SEND_RESULT = 'MIGRATE_USER_LEGACY_SEND_RESULT';

export const MIGRATE_USER_LEGACY_CONFIRM_CLOSE = 'MIGRATE_USER_LEGACY_CONFIRM_CLOSE';
export const MIGRATE_USER_LEGACY_CONFIRM = 'MIGRATE_USER_LEGACY_CONFIRM';
export const MIGRATE_USER_LEGACY_CONFIRM_RESULT = 'MIGRATE_USER_LEGACY_CONFIRM_RESULT';

export const SET_PERMISSIONS_TO_MIGRATE_THE_USER = 'SET_PERMISSIONS_TO_MIGRATE_THE_USER';